import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import ContactUs from './components/ContactUs';
//import Recipes from './components/Recipes';
import OurApp from './components/OurApp';
//import Events from './components/Events';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          {/*<Route path="/recipes" element={<Recipes />} />*/}
          <Route path="/our-app" element={<OurApp />} />
          {/*<Route path="/events" element={<Events />} />*/}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
